import React, { useEffect, useMemo, useRef } from "react";
import { initializeMathJax, processMathJax } from "./helper/mathjax-helper";
import { toHtml } from "./helper/markdown-helper";

interface MdLatexProps {
  text: string;
  className?: string;
}

const MdLatexComponent: React.FC<MdLatexProps> = ({ text, className }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const html = useMemo(() => toHtml(text), [text]);

  useEffect(() => {
    initializeMathJax();
  }, []);

  useEffect(() => {
    if (containerRef.current) processMathJax([containerRef.current]);
  }, [html]);

  return (
    <div
      ref={containerRef}
      className={`md-latex${className ? ` ${className}` : ""}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export const MdLatex = React.memo(MdLatexComponent);
